import _ from 'lodash';
import { useEffect, useRef, useState } from 'react';
import { Form } from 'react-bootstrap';
import { useLocation } from 'react-router-dom';
import { BLACK_DOWN_ARROW, MAIN_LOGO } from '../constants/assetConstants';
import OrgLogoPlaceholder from '../assets/images/organisation.svg';
import { apiCreateOrganization, apiGetAllMyOrgs } from '../helpers/api';
import { errorToast, successToast, warningToast } from '../helpers/toastHelper';
import { useSwitchToOrganization } from '../hooks/useSwitchToOrganization';
import { useUserContext } from '../contexts/UserContext';
import Button from '../components/Button/Button';
import { useClickAway } from 'react-use';
import { MODE, useApiList } from '../hooks/useApiList';
import InfiniteScroll from '../components/InfiniteScroll/InfiniteScroll';
import { Mixpanel, MxEvent } from './Mixpanel';
import { useCountryNameBasedOnTimezone } from '../hooks/useCountryNameBasedOnTimezone';
import {
  LogoutIcon,
  MySettingsIcon,
  MyTeamIcon,
  SettingsIcon,
  InviteMemberIcon,
  TermAndConditionIcon,
  PrivacyPolicy,
  CheckMarkIcon,
} from '../assets/icons';
import DotsIcon from '../components/icons/dots';
import { useNavigate } from 'react-router-dom';
import { useCheckCuratorActive } from '../hooks/useCuratorActive';
import {
  ADMIN_SETTINGS,
  INVITE_INTERNAL_USER,
  MY_TEAM_ROUTE,
  PRIVACY_POLICY_ROUTE,
  TERMS_OF_USE_ROUTE,
} from '../constants/routePathConstants';
import { CommonFeatureMenu } from '../layouts/Sidemenu';
import { SIDEBAR_MENU_V2_2 } from '../constants/menu';
import moment from 'moment';
import cx from "classnames"
import styles from './OrganizationSwitcher.module.scss'
import PlusIcon from '../components/icons/PlusIcon';
import { YouAreOnFreemium } from '../screens/subscriptionComponents/FloatingCardUI';
import { removeLocalStorage, removeUndefinedText, wait } from '../helpers/jsHelper';
import useCurrentOrganizationInfo from '../hooks/useCurrentOrganizationInfo';
import { useDispatch } from 'react-redux';
import { setAssignEditorPopOpen } from '../redux/slicers/uiSlicer';
import { sendDataToFrappeApp } from '../screens/Requests/RequestsV2';
import { setFrappeRequestData } from '../redux/slicers/activitySlicer';

export const OrganizationSwitcher = ({ setUserCardVisiblity, isGuestLogin,refreshOrgList }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch()
  const { switchToOrganization } = useSwitchToOrganization();
  // const { isCuratorActive } = useCheckCuratorActive();
  const { currentUser, logout, isGuestUser, showAssignPackModal , addCreatedAtDate } = useUserContext();
  const { hideNewPlans } = useCurrentOrganizationInfo();
  const { id, organization, organization_detail, user } = currentUser;
  const { name, thumbnail } = organization_detail || {};
  const location = useLocation();
  const [showOrgDropdown, setShowOrgDropdown] = useState(false);
  const [newOrgName, setNewOrgName] = useState('');
  const [showInput, setShowInput] = useState(false);
  const [saving, setSaving] = useState(false);

  const ref = useRef(null);
  useClickAway(ref, () => {
    setShowOrgDropdown(false);
  });

  // Expose method to close dropdown programmatically
  useEffect(() => {
    if(!showOrgDropdown) return;
    window.closeOpenedMenu = () => {
      setShowOrgDropdown(false);
    };
    return () => {
      delete window.closeOpenedMenu;
    };
  }, [showOrgDropdown]);

  const { countryName } = useCountryNameBasedOnTimezone();

  useEffect(() => {
    setShowOrgDropdown(false);
  }, [location]);

  const { refetch, fetchNextPage, hasMore, hasData, list, loading, total } = useApiList(
    {
      api: apiGetAllMyOrgs,
      defaultPerPage: 20,
      mode: MODE.PARAMS,
      params: {
        perPage: 20,
      },
    },
    [currentUser.id, showAssignPackModal]
  );

  useEffect(() => {
    if (name && organization && !organization_detail?.created_at) {
      list.find(({id})=> id === organization)?.created_at && addCreatedAtDate(moment(list.find(({id})=> id === organization)?.created_at).unix())
    }
  }, [list]);

  useEffect(() => {
    if (name && window.$updateName) {
      window.$updateName = null;
      refetch();
    }
  }, [name]);

  useEffect(() => {
    if (name && (!isGuestLogin || refreshOrgList)) {
      refetch();
    }
  }, [isGuestLogin, refreshOrgList]);

  async function handleOrgClick(orgId, orgName) {
    Mixpanel.track(true, MxEvent.CHANGED_ORGANIZATION, {
      organization_old_id: currentUser?.organization_detail?.id,
      organization_old_name: currentUser?.organization_detail?.name,
      organization_old_subscription_type: currentUser?.organization_detail?.subscription_type,
      organization_old_subscription_status_id: currentUser?.organization_detail?.status?.id,
      organization_old_subscription_status_name: currentUser?.organization_detail?.status?.name,
      organization_new_id: orgId,
      organization_new_name_new: orgName,
    });
    window.$recentProject = null;

    // clearning frappe app url on org switch. so, that new user logged in org will not face any issue
    // removeLocalStorage('FRAPPE_APP_URL');
    // removeLocalStorage('FRAPPE_APP_READY');
    // removeLocalStorage('FRAPPE_FULL_LOGIN_URL');
    // removeLocalStorage('FRAPPE_FETCHED_ORG');
    // dispatch(setFrappeRequestData({ url: null, fetchedForOrg: null }));
    // sendDataToFrappeApp({ logoutFrappe: true });
    // await wait(1000); // Wait for a second after logout

    switchToOrganization(orgId, {
      onSuccess: () => {
        setShowInput(false);
        setShowOrgDropdown(false);
        dispatch(setAssignEditorPopOpen(true));
      },
    });
  }

  const handleToggle = () => {
    setShowOrgDropdown(!showOrgDropdown);

    if(!showOrgDropdown) { // sending data only when the dropdown is opened
      sendDataToFrappeApp({
        app_dropdown_opened: true,
      });
    }
  };

  async function handleSave() {
    if (!newOrgName) {
      warningToast('Please provide the organization name.');
      return;
    }

    setSaving(true);
    const res = await apiCreateOrganization(newOrgName, id, countryName);
    if (res) { 
      refetch(); 
      successToast('Organization created successfully');
    }
    setShowInput(false);
    setNewOrgName('');
    setSaving(false);
  }

  const handleCancel = () => {
    setNewOrgName('');
    setShowInput(false);
  };

  // const handleRedirect = (url, newTab) => {
  //   if (url) {
  //     if (newTab) {
  //       window?.open(url,"_blank")
  //     }else{
  //       navigate(url);
  //     }
  //   }
  // };

  // async function handleLogout() {
  //   const curatorActive = await isCuratorActive();
  //   if (curatorActive) {
  //     errorToast('Please close or save any open project before logging out.');
  //     return;
  //   }

  //   Mixpanel.track(true, MxEvent.LOGIN_OUT_SUCCESS);

  //   Mixpanel.reset();
  //   Mixpanel.track(true, MxEvent.VISITED_LOGIN);

  //   logout();
  //   setUserCardVisiblity(false);
  // }

  return (
    <header id="OrganizationSwitcher" className={cx("organisation", styles.organisation)} ref={ref}>
      <a className={cx("organization-toggle", styles.organizationToggle)} onClick={() => handleToggle()}>
        <div className={styles.imageContainer}>
         <img className="orgImg" src={thumbnail || OrgLogoPlaceholder} alt="Organization" onError={(e) => e.target.setAttribute("src", OrgLogoPlaceholder)}/>
        </div>
        <span className={cx("menu-label d-flex align-items-start justify-content-center flex-column gap-1 hiddenOnMobile", styles.menuLabel)} title={name}>
          <span className={cx('menu-label', styles.menuLabel)}> {removeUndefinedText(name)}</span>
          {user?.name ? <span style={{color: "var(--dark-400)", fontSize: "14px"}}>{removeUndefinedText(user.name)}</span>: null}
        </span>
        
          <span role="button" className="downarrow">
            <img
              src={BLACK_DOWN_ARROW}
              alt=""
              style={showOrgDropdown ? { transform: "rotate(180deg)" } : null}
              width={16}
              height={10}
              className={styles.dropdown}
            />
              {/* <DotsIcon /> */}
          </span>
      </a>
      <nav className={cx("menu org-switch", styles.menu)} style={{ display: showOrgDropdown ? 'block' : 'none'}}>
        {/* <h5>
          <span className="text-muted">{name || "Organization"}</span>
        </h5> */}
        {!isGuestUser() ? (
          <>
            <div className={styles.orgInfo}> <img className="orgImg" src={thumbnail || OrgLogoPlaceholder} alt="Organization" onError={(e) => e.target.setAttribute("src", OrgLogoPlaceholder)}/>
              <span className={cx("d-flex align-items-start justify-content-center flex-column gap-1 w-75", styles.menuLabel)} >
                <span className="w-100 text-truncate" style={{color: "black" }} title={user.name}>{removeUndefinedText(user.name)}</span>
                <span className="w-100 text-truncate" style={{color: "var(--dark-400)", fontSize: "14px" }} title={user.email}>{user.email}</span>
              </span>
              </div>

            <div className={styles.seperator}></div>

            <OrganizationCard
                key={organization}
                org={organization_detail}
                name={name}
                isCurrentOrg
              />

              <li role="button" onClick={() => navigate(INVITE_INTERNAL_USER)}>
                  <span className="text-action d-flex align-items-center gap-2 pb-2"><PlusIcon/> Invite teammates</span>
                </li> 
            <ul style={{ maxHeight: '200px' }}>
              <InfiniteScroll
                dataLength={total}
                next={fetchNextPage}
                hasMore={hasMore}
                loading={loading}
                hasChildren={hasData}
                loadingType={null}
                scrollableTarget="infiniteScroll"
                containerClassName="org-list-box">
                <div style={{ maxHeight: '200' }}>
                  {list.map((a, i) => {
                    if (organization === a?.id) return null
                    return (
                      <OrganizationCard
                        key={a.id}
                        org={a}
                        name={name}
                        onClick={(_id) => handleOrgClick(_id, a?.name)}
                      />
                    );
                    // }
                  })}
                </div>
              </InfiniteScroll>
            </ul>

            {showInput ? (
              <div className="createOrgForm">
                <Form.Control
                  type="text"
                  name="orgname"
                  value={newOrgName}
                  maxLength={50}
                  onChange={(e) => setNewOrgName(e.target.value)}
                  placeholder="Enter name..."
                  autoFocus
                  onKeyDown={(e) => {
                    if (e.key !== 'Enter' || saving) return;
                    handleSave?.();
                  }}
                />
                <div className="d-flex align-items-center mt-2 gap-2">
                  <Button disabled={saving} className="cancel" onClick={handleCancel}>
                    Cancel
                  </Button>
                  <Button
                    color="warning"
                    disabled={saving}
                    loading={saving}
                    className="save"
                    onClick={handleSave}>
                    Save
                  </Button>
                </div>
              </div>
            ) : (
              //   <li role="button" onClick={() => setShowInput(true)}>
              //   <span className="text-action">+ Add Organization</span>
              // </li> 
              null
            )}
          </>
        ) : null}


        <div className={styles.seperator}></div>
          <li role="button" className={styles.createTeam} onClick={() => setShowInput(true)}>
              <span className={cx("d-flex align-items-senter justify-content-center", styles.plusIcon)} >{<PlusIcon />}</span>
              <span>Create team</span>
          </li>

        <CommonFeatureMenu
          navList={SIDEBAR_MENU_V2_2}
          menuClassName={cx("flex-column gap-0", styles.maxHeightFit)}
          menuItemClassName="px-0"
          floatingMenu={true}
        />
        {!hideNewPlans && <YouAreOnFreemium containerClassName={styles.upgradeButton}/>}
        {/* <ul className="other-option">
          <li onClick={() => handleRedirect(`${ADMIN_SETTINGS}?activeTab=members`)}>
            <MyTeamIcon /> My team
          </li>
          <li onClick={() => handleRedirect(INVITE_INTERNAL_USER)}>
            <InviteMemberIcon /> Invite member
          </li>
          <li onClick={() => handleRedirect(ADMIN_SETTINGS)}>
            <SettingsIcon /> Settings
          </li>
          <li onClick={() => handleRedirect(PRIVACY_POLICY_ROUTE , true)}>
            <PrivacyPolicy /> Privacy Policy
          </li>
          <li onClick={() => handleRedirect(TERMS_OF_USE_ROUTE , true)}>
            <TermAndConditionIcon /> Terms of Use
          </li>
          <li onClick={() => handleLogout()}>
            <LogoutIcon /> Log out
          </li>
        </ul> */}

      </nav>
    </header>
  );
};

export const OrganizationCard = ({ org, name, onClick, isCurrentOrg }) => {
  if (!org?.id) {
    return <></>
  }
  return (
    <li key={`orgItem${org.id}`} role="button" onClick={() => {
      if (!isCurrentOrg)
        onClick(org.id)
    }}>
      <span className="organization-avatar">
        {org?.thumbnail ? (
          <img src={org?.thumbnail} alt="profile" onError={(e) => e.target.setAttribute("src", OrgLogoPlaceholder)}/>
        ) : (
          org?.name?.trim()?.charAt(0) || 'O'
        )}
      </span>
      <span title={org.name} className={isCurrentOrg ? styles.currentOrg : ""}>
        {org.name}
      </span>
      {name === org.name && <CheckMarkIcon color="#2B2A28" />}
    </li>
  );
};
